export default "__VITE_ASSET__CndJ5GSi__"